import { React, useState, useEffect } from 'react';
import {
  SidebarQuarterlyContainer,
  AccordionTitle,
  AccordionTitleContainer,
  AccordionContent,
  AccordionContentFuture,
  AccordionText,
  OrangeColorStyle,
  RowStyle,
  LegendTextStyle,
  GreenColorStyle,
  WonAccordianValue,
} from '../../../atoms/sidebar/sidebar.styles';
import Legend from './legend';
import MontlySideBar from './montlySideBar';
import flagOutline from '../../../assets/icons/flagOutline.png';
import { CrmChartQuarterly } from './crmChartQuarterly';
import { formatNumberWithKAndM, getTodaysDate } from '../../../../util/commonUtil';
import {
  Recoil_Quarter_State,
  Year_Wise_Data_State,
  Current_User,
  System_Date_Time_State,
} from '../../../../recoil/recoil';
import { useRecoilState, useRecoilValue } from 'recoil';
import axios from 'axios';
import client from '../../../../services/TokenInterceptorServices';
import { pastSidebarPL } from '../../../../services/pursuitLeaderServices';

const PlPastQuarterlySidebar = props => {
  const [expandedQuarter, setExpandedQuarter] = useState('');
  const [yearQuaterWiseData, setYearQuaterWiseData] = useRecoilState(Year_Wise_Data_State);
  const quarterData = useRecoilValue(Recoil_Quarter_State);
  const currentUser = useRecoilValue(Current_User);
  const systemDateTime = useRecoilValue(System_Date_Time_State);
  let todaysDate = getTodaysDate(systemDateTime);
  let currentYear;
  let month = props.data.month;
  month = month.charAt(0).toUpperCase() + month.slice(1);
  let quarter = props.data.quarter;

  setTimeout(() => {
    if (quarterData != null && expandedQuarter == '') {
      let expandThisQuarter = quarterData.quarter;
      setExpandedQuarter(expandThisQuarter);
    }
  }, 1000);

  if (quarterData != null) {
    currentYear = quarterData.fiscal_year;
  }

  const EMAIL = currentUser.email;
  const YEAR = currentYear;
  const QUARTER = quarter;
  const DATE = systemDateTime;
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (quarterData != null) {
          const data = await pastSidebarPL(EMAIL, YEAR, QUARTER, DATE);
          setYearQuaterWiseData(data);
        }
      } catch (error) {
        console.error('Error:', error);
      }
    };

    fetchData();
  }, [currentUser.email, currentYear, quarter, quarterData, systemDateTime]);
  const toggleAccordion = quarter => {
    if (expandedQuarter === quarter) {
      setExpandedQuarter(null);
    } else {
      setExpandedQuarter(quarter);
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        paddingTop: 20,
        gap: '20px',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      {' '}
      {quarter === 'Q1' && (
        <SidebarQuarterly
          data={yearQuaterWiseData['Q1']}
          quarter="Q1"
          expanded={quarter === 'Q1'}
          toggleAccordion={() => toggleAccordion('Q1')}
          propsData={props.data}
        />
      )}
      {quarter === 'Q2' && (
        <SidebarQuarterly
          data={yearQuaterWiseData['Q2']}
          quarter="Q2"
          expanded={quarter === 'Q2'}
          toggleAccordion={() => toggleAccordion('Q2')}
          propsData={props.data}
        />
      )}
      {quarter === 'Q3' && (
        <SidebarQuarterly
          data={yearQuaterWiseData['Q3']}
          quarter="Q3"
          expanded={quarter === 'Q3'}
          toggleAccordion={() => toggleAccordion('Q3')}
          propsData={props.data}
        />
      )}
      {quarter === 'Q4' && (
        <SidebarQuarterly
          data={yearQuaterWiseData['Q4']}
          quarter="Q4"
          expanded={quarter === 'Q4'}
          toggleAccordion={() => toggleAccordion('Q4')}
          propsData={props.data}
        />
      )}
    </div>
  );
};

const SidebarQuarterly = ({ data, quarter, expanded, toggleAccordion, propsData }) => {
  return (
    <SidebarQuarterlyContainer className={expanded ? 'expanded' : 'collapsed'}>
      <AccordionTitle style={{ padding: '15px 0px 15px 15px' }} onClick={toggleAccordion}>
        <h3>{quarter}</h3>
        <AccordionTitleContainer>
          <GreenColorStyle />
          <LegendTextStyle>Won</LegendTextStyle>
          {!!data && data['quarterlyCalculation']?.period == 'past' && (
            <WonAccordianValue>
              {formatNumberWithKAndM(data['quarterlyCalculation']?.sold) || 0}
            </WonAccordianValue>
          )}
        </AccordionTitleContainer>
      </AccordionTitle>

      {!!data && data['quarterlyCalculation']?.period == 'past' && (
        <AccordionContent>
          <CrmChartQuarterly quarterlyData={data['quarterlyCalculation']} />
          <Legend quarterlyData={data['quarterlyCalculation']} quarterText={quarter} />
          <AccordionText style={{ color: '#ffffff' }}>
            No Commit: {formatNumberWithKAndM(data['quarterlyCalculation']?.noCommit) || 0}
          </AccordionText>
        </AccordionContent>
      )}

      {!!data && data['quarterlyCalculation']?.period == 'future' && (
        <AccordionContentFuture>
          <img src={flagOutline} alt=" " />
          <span>{formatNumberWithKAndM(data['quarterlyCalculation']?.commit) || 0}</span>
          <RowStyle>
            <OrangeColorStyle />
            <LegendTextStyle>Commit</LegendTextStyle>
          </RowStyle>
          <AccordionText style={{ color: '#ffffff' }}>
            No Commit: {formatNumberWithKAndM(data['quarterlyCalculation']?.noCommit) || 0}
          </AccordionText>
        </AccordionContentFuture>
      )}

      {!!data && <MontlySideBar quarterData={data} propsData={propsData} />}
    </SidebarQuarterlyContainer>
  );
};

export default PlPastQuarterlySidebar;
